/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

function Table5({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: 0,
      value4: 0,
      value5: 0,
      value6: 0,
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box style={{ maxWidth: "100%" }}>
        <table style={tableStyle}>
          <tbody>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Tên hàng hoá, dịch vụ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Giá trị hàng hoá, dịch vụ chưa có thuế GTGT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế xuất theo quy định
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế xuất sau giảm
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>
                Thuế GTGT được giảm
              </Th>
            </tr>
            <tr style={{ background: "#eaeae9" }}>
              <Th style={{ textAlign: "right" }} className="toggle-button">
                (1)
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Th>
              <Th style={{ textAlign: "center"}}>(2)</Th>
              <Th style={{ textAlign: "center"}}>(3)</Th>
              <Th style={{ textAlign: "center"}}>(4)</Th>
              <Th style={{ textAlign: "center"}}>(5)=(4)*80%</Th>
              <Th style={{ textAlign: "center"}}>(6)=(3)x[(4)-(5)]</Th>
            </tr>

            {data.muc1.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "right" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "right", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="number"
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>{item.value4}</Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>{item.value5}</Td>
                <Td style={{ textAlign: "right", background: "#ddeff3" }}>{item.value6}</Td>
              </tr>
            ))}
            <tr>
            <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
            <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold"  }}>Tổng cộng</Td>
            <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold"  }}>0</Td>
            <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
            <Td style={{ textAlign: "right", background: "#ddeff3" }}></Td>
            <Td style={{ textAlign: "right", background: "#ddeff3", fontWeight: "bold"  }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table5);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else if (type === "date") {
      onChange({ value, name, type, id, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(value)) return;
      onChange({ value, name, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      name={name}
      style={{
        width: "100%",
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
